export enum InfoMessage {
  FilterCanceling = 'FilterCanceling'
}
